<template>
<div class="login-wrap">
  <div class="login-html">
    <label v-if="tab !== 3" @click="$router.replace('/login'); reset(1)" :class="{tab: 1, 'check-tab': tab === 1}">{{$t('auth.tab1_login')}}</label>
    <label v-if="tab !== 3" @click="$router.replace('/register'); reset(2)" :class="{tab: 1, 'check-tab': tab === 2}">{{$t('auth.tab2_register')}}</label>

    <label v-if="tab == 3" class="tab check-tab width-full">{{$t('auth.esqueceu_senha_titulo')}}</label>

    <div class="login-form">
      <div class="sign-in-htm" v-if="tab === 1">
        <form autocomplete="false" method="POST">
          <div class="group">
            <label class="label">{{$t('email')}}</label>
            <input required type="email" v-model="login.email" class="input" :placeholder="$t('input_email')" autocomplete="false">
          </div>
          <div class="group">
            <label class="label">{{$t('password')}}</label>
            <input required type="password" v-model="login.password" class="input" data-type="password" autocomplete="false" :placeholder="$t('input_password')">
            <div class="text-center m-t-10"><router-link to="/forgot" @click="reset(3)" class="text-white m-t-10 text-uppercase">{{$t('auth.esqueceu_senha')}}</router-link></div>
          </div>

          <div class="group m-t-50">
            <input type="submit" @click="FNlogin" class="button" :value="$t('auth.btn_login')">
          </div>
        </form>
      </div>

      <div class="sign-up-htm" v-if="tab === 2">
        <form autocomplete="false" method="POST" novalidate="true" onsubmit="return false;">
          <div class="group">
            <label class="label">{{$t('name')}}</label>
            <input required type="text" v-model="register.name" class="input" autocomplete="false" :placeholder="$t('input_name')">
          </div>
          <div class="group pr">
            <label class="label">{{$t('birthdate')}}</label>
            <select required class="input aniversario" v-model="register.day">
              <option value="">{{$t('dia')}}</option>
              <option :value="dia" v-for="(dia, index) in 31" :key="index">{{dia}}</option>
            </select>
            <select required class="input aniversario" v-model="register.month">
              <option value="">{{$t('mes')}}</option>
              <option :value="mes" v-for="(mes, index) in 12" :key="index">{{mes}}</option>
            </select>
            <select required class="input aniversario" v-model="register.year">
              <option value="">{{$t('ano')}}</option>
              <option :value="ano" v-for="(ano, index) in anos" :key="index">{{ano}}</option>
            </select>
            <div class="clearfix"></div>
          </div>

          <div class="group">
            <label class="label">{{$t('username')}}</label>
            <input required type="text" v-model="register.username" class="input" autocomplete="false" :placeholder="$t('input_username')">
          </div>
          <div class="group">
            <label class="label">{{$t('email')}}</label>
            <input required type="email" v-model="register.email" class="input" autocomplete="false" :placeholder="$t('input_email')">
          </div>
          <div class="group">
            <label class="label">{{$t('password')}}</label>
            <input required type="password" v-model="register.password" class="input" data-type="password" autocomplete="false" :placeholder="$t('input_password')">
          </div>
          <div class="group">
            <div class="form-check mao">
              <input class="form-check-input" v-model="register.condicoes" type="checkbox" value="" id="fafdsfsdf-432">
              <label class="form-check-label" for="fafdsfsdf-432" v-html="$t('auth.condicoes_servico')"></label>
            </div>
          </div>

          <div class="group">
            <input type="submit" @click="FNregister" class="button" :value="$t('auth.btn_register')">
          </div>
        </form>
      </div>

      <div class="forgot-htm" v-if="tab === 3">
        <div v-if="forgotSuccess">
          <p class="text-justify text-white" v-html="$t('auth.forgot_desc_success')"></p>
        </div>
        <div v-else>
          <form autocomplete="false" method="POST" novalidate="true" onsubmit="return false;">
            <div class="group">
              <label class="label">{{$t('email')}}</label>
              <input required type="email" v-model="forgot.email" class="input" :placeholder="$t('input_email')">
            </div>
            <div class="group">
              <input type="submit" @click="FNforgot" class="button" :value="$t('auth.btn_forgot')">
            </div>
          </form>
          <div class="foot-lnk">
            <router-link to="/login" @click="reset(1)" class="button  button11 m-t-10">{{$t('cancelar')}}</router-link>
          </div>
        </div>
      </div>

    </div>
    <div class="hr"></div>
    <div class="text-center">
      <a class="m-l-10 m-r-10" @click="lang = 'pt'; $i18n.setLocale('pt')"><img src="data:image/jpeg;base64,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" alt="PT" /></a>
      <a class="m-l-10 m-r-10" @click="lang = 'en'; $i18n.setLocale('en')"><img src="data:image/png;base64,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" alt="EN" /></a>
    </div>
  </div>
</div>
</template>

<script>
import { login, register } from '../resources/fn'
import { success, error } from '../resources/functions'
import { mapMutations } from 'vuex'
// import { add } from 'date-fns

export default {
  name: 'auth',
  data () {
    return {
      login: {},
      register: {},
      forgot: {},
      tab: 1,
      forgotSuccess: false,
      lang: null,
      anos: []
    }
  },
  beforeMount () {
    this.SET_LOAD(true)
    switch (window.location.pathname.split('/')[1]) {
      case 'register':
        this.tab = 2
        break
      case 'forgot':
        this.tab = 3
        break
      default:
        this.tab = 1
    }
    this.reset(this.tab)
    /*
    if (window.location.pathname.split('/')[1] === 'register') {
      this.tabRegister = true
      // var a = new Date()
      // this.disabledDate = add(new Date(a.getFullYear() - 18, a.getMonth() + 1, a.getDate()), { days: 1 })
      // document.getElementById('tab2').click()
    }
    */
    this.anos = []
    let ano = new Date().getFullYear() - 17
    while (--ano > 1900) {
      this.anos.push(ano)
    }
  },
  mounted () {
    this.SET_LOAD()
  },
  methods: {
    ...mapMutations([
      'SET_USER',
      'SET_LOAD'
    ]),
    reset (tab) {
      this.tab = tab
      this.login = {
        email: '',
        password: ''
      }
      this.register = {
        name: '',
        email: '',
        password: '',
        username: '',
        birthdate: '',
        day: '',
        month: '',
        year: '',
        condicoes: false
      }
      this.forgot = {
        email: ''
      }
      this.forgotSuccess = false
    },
    FNlogin () {
      if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(this.login.email)) {
        error(this, this.$t('email_erro'))
        return
      }
      this.SET_LOAD(true)
      login(this.axios, this.login).then((res) => {
        this.SET_USER(res.data)
        // this.$router.replace('/')
      }, (res) => {
        error(this, res.error)
        this.SET_LOAD()
      })
    },
    FNregister () {
      if (this.register.name < 3) {
        error(this, this.$t('nome_erro'))
        return
      }
      if (isNaN(Date.parse(this.register.year, this.register.month, this.register.day))) {
        error(this, this.$t('data_aniversario_erro'))
        return
      }
      this.register.birthdate = this.register.year + '-' + ('0' + this.register.month).slice(-2) + '-' + ('0' + this.register.day).slice(-2)

      if (!/^[A-Za-z0-9_]{2,20}$/.test(this.register.username)) {
        error(this, this.$t('username_erro'))
        return
      }
      if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(this.register.email)) {
        error(this, this.$t('email_erro'))
        return
      }
      if (this.register.password.length < 8) {
        error(this, this.$t('password_erro'))
        return
      }
      if (!this.register.condicoes) {
        error(this, this.$t('auth.condicoes_utilizacao_erro'))
        return
      }
      this.SET_LOAD(true)
      register(this.axios, this.register).then((res) => {
        success(this, this.$t('auth.register_sucesso'))
        this.SET_USER(res.data)
        this.$router.replace('/')
      }, (res) => {
        error(this, res.error)
        this.SET_LOAD()
      })
    },
    FNforgot () {
      if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(this.forgot.email)) {
        error(this, this.$t('email_erro'))
        return
      }
      this.SET_LOAD(true)
      /*
      register(this.axios, this.forgot).then((res) => {
        success(this, this.$t('auth.forgot_sucesso'))
        this.forgotSuccess = true
        this.SET_LOAD()
      }, (res) => {
        error(this, res.error)
        this.SET_LOAD()
      })
      */
    }
  }
}

</script>

<style type="text/css" media="screen">
*,:after,:before{box-sizing:border-box}
.clearfix:after,.clearfix:before{content:'';display:table}
.clearfix:after{clear:both;display:block}
a{color:inherit;text-decoration:none}

.login-wrap{
  width:100%;
  margin:auto;
  max-width:525px;
  position:relative;
  background:url(https://raw.githubusercontent.com/khadkamhn/day-01-login-form/master/img/bg.jpg) no-repeat center;
  box-shadow:0 12px 15px 0 rgba(0,0,0,.24),0 17px 50px 0 rgba(0,0,0,.19);
}
.login-html{
  width:100%;
  height:100%;
  padding:70px 50px 50px 50px;
  background:rgba(40,57,101,.9);
}
.login-form {margin-top:35px;}
.login-html .tab,
.label,
.login-form .group .button{
  text-transform:uppercase;
}
.login-html .tab{
  font-size:24px;
  margin-right:15px;
  padding-bottom:5px;
  margin:0;
  display:inline-block;
  border-bottom: 2px solid transparent;
  cursor:pointer;
  width:50%;
  color:#fff;
  text-align: center;
}
.login-form{
  position:relative;
}
.login-form .group{
  margin-bottom:15px;
}
.label,
.login-form .group .input,
.login-form .group .button{
  width:100%;
  color:#fff;
  display:block;
}
.login-form .group .input,
.login-form .group .button{
  border:none;
  padding:15px 20px;
  border-radius:25px;
  background:rgba(255,255,255,.1);
}
.login-form .group input[data-type="password"]{
  text-security:circle;
  -webkit-text-security:circle;
}
.label{
  color:#aaa;
  font-size:13px;
}
.login-form .group .button{
  background:#1161ee;
}
.login-form .group label .icon{
  width:15px;
  height:15px;
  border-radius:2px;
  position:relative;
  display:inline-block;
  background:rgba(255,255,255,.1);
}
.login-form .group label .icon:before,
.login-form .group label .icon:after{
  content:'';
  width:10px;
  height:2px;
  background:#fff;
  position:absolute;
}
.login-form .group label .icon:before{
  left:3px;
  width:5px;
  bottom:6px;
}
.login-form .group label .icon:after{
  top:6px;
  right:0;
}
.login-form .group .check:checked + label{
  color:#fff;
}
.login-form .group .check:checked + label .icon{
  background:#1161ee;
}
.check-tab {
  border-color:#1161ee !important;
  display: block;
}

.hr{
  height:2px;
  margin:50px 0 50px 0;
  background:rgba(255,255,255,.2);
}
.foot-lnk{
  text-align:center;
}
</style>
